import { render, staticRenderFns } from "./ItemSummary.vue?vue&type=template&id=43c68155&scoped=true&lang=pug"
import script from "./ItemSummary.vue?vue&type=script&lang=js"
export * from "./ItemSummary.vue?vue&type=script&lang=js"
import style0 from "./ItemSummary.vue?vue&type=style&index=0&id=43c68155&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c68155",
  null
  
)

export default component.exports